import { Box, Typography } from '@mui/material';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import type { StorePerfRow } from './storePerformanceModel';

/**
 * Grouped bar chart of clicks and conversions by store for one band, built on
 * Recharts - the reports-suite charting choice adopted on this surface
 * (D-store-performance). It visualises the ranked leaderboard (the stores the
 * table ranks), so the funnel gap between clicks and conversions reads at a
 * glance. The shipped Earnings trend stays hand-rolled SVG; it is not migrated.
 */

const CLICKS_COLOR = '#1565c0';
const CONVERSIONS_COLOR = '#2e7d32';

export const StorePerformanceChart = ({ rows }: { rows: StorePerfRow[] }) => {
  const data = rows.map((r) => ({
    name: r.name,
    clicks: r.clicks,
    conversions: r.conversions,
  }));

  return (
    <Box aria-label="store performance chart">
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Clicks and conversions by store
      </Typography>
      <ResponsiveContainer width="100%" height={320}>
        <BarChart
          data={data}
          margin={{ top: 8, right: 16, bottom: 8, left: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="name" tick={{ fontSize: 12 }} interval={0} />
          <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
          <Tooltip />
          <Legend />
          <Bar name="Clicks" dataKey="clicks" fill={CLICKS_COLOR} />
          <Bar
            name="Conversions"
            dataKey="conversions"
            fill={CONVERSIONS_COLOR}
          />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};
